import { useEffect, useState } from "react";
import {
	LANGUAGE_JSON_STORAGE_KEY,
	addNewJSONStringsAsKeysIfNeeded,
	getDateTimePlusHour,
	getDeviceInfo,
	getMasterKeyByHost,
	globalAny,
	isProduction,
	logout,
	validateCustomerZone,
} from "../../utils/Utils";
import useSessionStore from "../../store/useSession.store";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { AsyncStorageKeys, CarActivity, Pages, Themes, Toggles } from "../../Types";
import CustomizeDialogBox from "../DialogMessageBox/CustomizeDialogBox";
import ComponentTypeEnum from "../../models/ComponentTypeEnum";
import Toast from "../Toast";
import { getApiKey } from "../../services/apiKeyService";
import { AppLogger } from "../../utils/AppLogger";
import { EN } from "../../utils/Strings";
import { getLanguage as getLanguageApi } from "../../services/appWordingService";
import useLoginStore from "../../store/useLogin.store";
import useDrivingStore from "../../store/useDriving.store";
import useGenericContentStore from "../../store/genericContent.store";
import useMqttStore from "../../store/useMqtt.store";
import DebugDialog from "../DialogMessageBox/DebugDialog";
import { Dimensions, View } from "react-native";
import LandingLoader from "../../components/Loaders/LandingLoader";
import { getMaintenanceConfig, getMaintenanceLanguage, renewSession, renewVoucher } from "../../services/loginService";
import { getFeatureFlags } from "../../services/featureFlagService";
import useToggleStore from "../../store/useToggle.store";
import { getUserOptions, infoSubscription } from "../../services/accountService";
import usePaymentTransactionStore from "../../store/usePaymentTransaction.store";
import { getLocation } from "../../services/locationService";
import useAcceptDataStore from "../../store/useAcceptData.store";
import useOtherDataStore from "../../store/useOtherData.store";
import { UserOptionSettings } from "../../enums/UserOptionSettings";
import useScreenDimensions from "../../hooks/useScreenDimensions";
import InitialLandingLoader from "../Loaders/InitialLandingLoader";
import ENV_CONFIG from "../../config/ENV_CONFIG";
import { CustomerZoneEnum } from "../../enums/CustomerZoneEnum";

let logoutInterval: NodeJS.Timeout;
let loginInterval: any;
let maintenanceModeInterval: any;
globalAny.language = { ...EN.Strings };
//@ts-ignore
const SessionWrapper = ({ children }) => {
	const [showIdleModal, setShowIdleModal] = useState(false);
	const [showLogout, setShowLogout] = useState(false);
	const [logoutCountDown, setLogoutCountDown] = useState(60);
	const [loginCountDown, setLoginCountDown] = useState(5);
	const [isNetworkError, setIsNetworkError] = useState(false);
	const isLogout = useSessionStore((state: any) => state.isLogout);
	const setIsLogout = useSessionStore((state: any) => state.setIsLogout);
	const isTimerRunning = useSessionStore((state: any) => state.isTimerRunning);
	const setIsTimerRunning = useSessionStore((state: any) => state.setIsTimerRunning);
	const isSigninLoading = useSessionStore((state: any) => state.isSigninLoading);
	const setIsSigninLoading = useSessionStore((state: any) => state.setIsSigninLoading);
	const setCurrentTheme = useGenericContentStore((state: any) => state.setCurrentTheme);
	const setIsEnabledFloatingButton = useGenericContentStore((state: any) => state.setIsEnabledFloatingButton);
	const setIsDebugVisible = useGenericContentStore((state: any) => state.setIsDebugVisible);
	const isDebugVisible = useGenericContentStore((state: any) => state.isDebugVisible);
	const setDimensions = useGenericContentStore((state: any) => state.setDimensions);
	const isMaintenance = useGenericContentStore((state: any) => state.isMaintenance);
	const setIsMaintenance = useGenericContentStore((state: any) => state.setIsMaintenance);
	const setIsNarrow = useGenericContentStore((state: any) => state.setIsNarrow);
	const setCarActivity = useDrivingStore((state: any) => state.setCarActivity);
	const setIsInitialLoading = useLoginStore((state: any) => state.setIsInitialLoading);
	const isLoggedIn = useLoginStore((state: any) => state.isLoggedIn);
	const setIsLoggedIn = useLoginStore((state: any) => state.setIsLoggedIn);
	const setCheckingLoginInfo = useLoginStore((state: any) => state.setCheckingLoginInfo);
	const checkingLoginInfo = useLoginStore((state: any) => state.checkingLoginInfo);
	const isLoginSuccess = useSessionStore((state: any) => state.isLoginSuccess);
	const setDeviceInfo = useMqttStore((state: any) => state.setDeviceInfo);
	const setDeviceName = useMqttStore((state: any) => state.setDeviceName);
	const setIsToggleQR = useToggleStore((state: any) => state.setIsToggleQR);
	const setIsToggleAutoLogin = useToggleStore((state: any) => state.setIsToggleAutoLogin);
	const setIsToggleMQTT = useToggleStore((state: any) => state.setIsToggleMQTT);
	const setIsToggleAdvanceSettings = useToggleStore((state: any) => state.setIsToggleAdvanceSettings);
	const setIsToggleBehindTheScene = useToggleStore((state: any) => state.setIsToggleBehindTheScene);
	const setIsEnableMobilePayment = usePaymentTransactionStore((state: any) => state.setIsEnableMobilePayment);
	const setMobilePaymentTerritories = usePaymentTransactionStore((state: any) => state.setMobilePaymentTerritories);
	const setIsToggleSKLegals = useToggleStore((state: any) => state.setIsToggleSKLegals);
	const setIsToggleHideDataMgmt = useToggleStore((state: any) => state.setIsToggleHideDataMgmt);
	const setIsShimmerLoading = useToggleStore((state: any) => state.setIsShimmerLoading);
	const setIsMqttMessageAckEnabled = useToggleStore((state: any) => state.setIsMqttMessageAckEnabled);
	const setIsScreenSelection = useToggleStore((state: any) => state.setIsScreenSelection);
	const isUrlValidation = useToggleStore((state: any) => state.isUrlValidation);
	const setIsUrlValidation = useToggleStore((state: any) => state.setIsUrlValidation);
	const setIsServicePreview = useToggleStore((state: any) => state.setIsServicePreview);
	const isScreenSelection = useToggleStore((state: any) => state.isScreenSelection);
	const setIsSubscriptionInfo = useToggleStore((state: any) => state.setIsSubscriptionInfo);
	const setIsDemoOptionsEnabled = useToggleStore((state: any) => state.setIsDemoOptionsEnabled);
	const setIsEnablePayment = usePaymentTransactionStore((state: any) => state.setIsEnablePayment);
	const setIsRetryTriggered = useGenericContentStore((state: any) => state.setIsRetryTriggered);
	const setIsAppNotSupported = useGenericContentStore((state: any) => state.setIsAppNotSupported);
	const isAppNotSupported = useGenericContentStore((state: any) => state.isAppNotSupported);
	const { setAcceptData } = useAcceptDataStore();
	const { setOtherData, setGoogleData, setVideoAnalyticsData } = useOtherDataStore();
	const { width, height } = useScreenDimensions();
	let viewport = document.querySelector("meta[name=viewport]");

	const onDismissSnackBar = () => {
		setShowLogout(false);
		setIsLogout(false);
		logout();
	};

	const idleLogout = () => {
		setIsLogout(true);
		setIsTimerRunning(false);
		setShowIdleModal(false);
		AsyncStorage.setItem(AsyncStorageKeys.idleExpiry, getDateTimePlusHour().toString());
		setLogoutCountDown(60);
	};

	const idleLogin = () => {
		setShowIdleModal(false);
		setLogoutCountDown(60);
		AsyncStorage.setItem(AsyncStorageKeys.idleExpiry, getDateTimePlusHour().toString());
		setIsTimerRunning(true);
	};

	const isSessionExpired = (sessionExpiry: string) => {
		const now = new Date();
		const sessionExpiryDate = new Date(sessionExpiry);
		return now > sessionExpiryDate;
	};

	const modalBody = () => {
		const bodyText = globalAny.language.modal_logout_body.split("\\n");
		return (
			<View>
				{bodyText.map((text: any) => (
					<View key={`logout-modal-body-text-${text}`}>{text.replace("%d", logoutCountDown.toString())}</View>
				))}
			</View>
		);
	};

	const verifyStorageData = async (isLoggedIn: boolean) => {
		const currentEmail = localStorage.getItem(AsyncStorageKeys.email);
		const currentSession = localStorage.getItem(AsyncStorageKeys.session);
		const currentSessionExpiry = localStorage.getItem(AsyncStorageKeys.sessionExpiry) ?? "1990-01-01";
		const consumerId = localStorage.getItem(AsyncStorageKeys.consumerId);
		const currentProfileName = localStorage.getItem(AsyncStorageKeys.profileName);
		const currentDeviceId = localStorage.getItem(AsyncStorageKeys.deviceId);
		const hwid = localStorage.getItem(AsyncStorageKeys.hwid);

		AsyncStorage.getItem(AsyncStorageKeys.theme).then((value) => setCurrentTheme(value ?? Themes.DARK));
		AsyncStorage.getItem(AsyncStorageKeys.carActivity).then((value) => setCarActivity(value ?? CarActivity.PARKED));
		AsyncStorage.getItem(AsyncStorageKeys.floatingButton).then((value) => setIsEnabledFloatingButton(value == "true"));

		const ready =
			currentEmail != null &&
			currentSession != null &&
			consumerId != null &&
			currentDeviceId != null &&
			!isSessionExpired(currentSessionExpiry);

		setIsTimerRunning(ready);

		if (ready) {
			const deviceInfo = getDeviceInfo();
			if (currentSession) globalAny.SESSIONKEY = currentSession;
			if (!isLoggedIn) await renewSession();
			setIsLoggedIn(true);
			if (hwid) await renewVoucher(localStorage.getItem(AsyncStorageKeys.session));
			await infoSubscription();
			if (consumerId) globalAny.CONSUMERID = consumerId;
			if (currentProfileName && currentDeviceId) {
				globalAny.profileName = currentProfileName;
				setDeviceName(currentProfileName);
				setDeviceInfo(deviceInfo);
			}
		}
	};

	const loadStrings = async () => {
		let strings = localStorage.getItem(AsyncStorageKeys.languageJson);
		let maintenanceStrings: any = await getMaintenanceLanguage();
		if (strings) {
			const parsedLanguages = JSON.parse(strings);
			globalAny.language = { ...EN.Strings, ...parsedLanguages, pass_rules: EN.Strings["pass_rules"], ...maintenanceStrings };
			addNewJSONStringsAsKeysIfNeeded();
		}

		try {
			let languageJSON = await getLanguageApi();
			if (!languageJSON) setIsAppNotSupported(true);
			if (languageJSON) {
				// @ts-ignore
				globalAny.language = { ...EN.Strings, ...languageJSON, pass_rules: EN.Strings["pass_rules"], ...maintenanceStrings };

				// add keys if they dont exist on server, but do locally
				addNewJSONStringsAsKeysIfNeeded();
				await AsyncStorage.setItem(LANGUAGE_JSON_STORAGE_KEY, JSON.stringify(languageJSON));
			}
		} catch (err) {
			// failing to get json from api is ok
			AppLogger.log(err);
		}
	};

	/**
	 * Fetch and apply feature flag values from Unleash.
	 *
	 * - Defines a list of toggle keys to fetch.
	 * - Filters out `advanceSettings` toggle if in production.
	 * - Retrieves feature flags from Unleash.
	 * - Applies toggle values using their respective setters.
	 * - Sets specific flags like mobile payment and territory support.
	 */
	const getUnleashFlags = async () => {
		const toggleParams = [
			Toggles.qrCode,
			Toggles.autoLogin,
			Toggles.mqtt,
			Toggles.advanceSettings,
			Toggles.mobilePayment,
			Toggles.mobilePaymentTerritoryKr,
			Toggles.behindTheScene,
			Toggles.skLegals,
			Toggles.disableDataManagement,
			Toggles.shimmerLoading,
			Toggles.mqttMessageAck,
			Toggles.screenSelection,
			Toggles.urlValidation,
			Toggles.servicePreview,
			Toggles.subscriptionInfo,
			Toggles.payment,
			Toggles.demoOptions,
		];

		const filteredParams = isProduction() ? toggleParams.filter((toggle) => toggle !== Toggles.advanceSettings) : toggleParams;

		const featureFlags: any = await getFeatureFlags(filteredParams);
		const toggles = featureFlags?.toggles;
		if (!toggles) return;

		const findToggle = (name: string) => toggles.find((flag: any) => flag.name === name);

		const toggleMap: Record<string, (enabled: boolean) => void> = {
			[Toggles.qrCode]: setIsToggleQR,
			[Toggles.autoLogin]: setIsToggleAutoLogin,
			[Toggles.mqtt]: setIsToggleMQTT,
			[Toggles.behindTheScene]: setIsToggleBehindTheScene,
			[Toggles.skLegals]: setIsToggleSKLegals,
			[Toggles.disableDataManagement]: setIsToggleHideDataMgmt,
			[Toggles.shimmerLoading]: setIsShimmerLoading,
			[Toggles.advanceSettings]: setIsToggleAdvanceSettings, // only for non-production
			[Toggles.mqttMessageAck]: (enabled) => {
				setIsMqttMessageAckEnabled(enabled);
				globalAny.isMqttMessageAckEnabled = enabled;
			},
			[Toggles.screenSelection]: setIsScreenSelection,
			[Toggles.urlValidation]: setIsUrlValidation,
			[Toggles.servicePreview]: setIsServicePreview,
			[Toggles.subscriptionInfo]: setIsSubscriptionInfo,
			[Toggles.payment]: setIsEnablePayment,
			[Toggles.demoOptions]: setIsDemoOptionsEnabled,
		};

		Object.entries(toggleMap).forEach(([toggle, setter]) => {
			if (toggle === Toggles.advanceSettings && isProduction()) return;
			const flag = findToggle(toggle);
			if (flag) setter(flag.enabled);
		});

		const mobilePayment = findToggle(Toggles.mobilePayment);
		if (mobilePayment) setIsEnableMobilePayment(mobilePayment.enabled);

		const mobilePaymentTerritories = [];
		const territoryKR = findToggle(Toggles.mobilePaymentTerritoryKr);
		if (territoryKR?.enabled) mobilePaymentTerritories.push("KR");
		setMobilePaymentTerritories(mobilePaymentTerritories);
	};

	const setUserLoginSessionInfo = async () => {
		const apiKey = await AsyncStorage.getItem(AsyncStorageKeys.apiKey);
		const getUrl = window.location.host;
		const masterKey: string = getMasterKeyByHost(getUrl) ?? ENV_CONFIG.MASTER_API_KEY;
		// 1. get api key and country
		try {
			await getApiKey(masterKey);
			if (apiKey) globalAny.APIKEY = apiKey;
		} catch (err) {
			// no api-key, fatal error
			AppLogger.log(err);
		}

		// 2. verify storage data such as profileName, deviceId, session, email
		await verifyStorageData(isLoggedIn);
		// 3. load strings from storage
		await loadStrings();

		await getUnleashFlags();
		setIsInitialLoading(true);

		if (!isLoggedIn) setCheckingLoginInfo(false);
	};

	const validateMaintenanceMode = async () => {
		const { settings }: any = await getMaintenanceConfig();

		if (!settings) {
			AppLogger.error("MAINTENANCE-MODE", "Failed to Fetch maintenance config");
			return;
		}

		const { maintenanceMode } = settings;
		const { countries } = maintenanceMode;
		AppLogger.log("MAINTENANCE-MODE", maintenanceMode);

		if (maintenanceMode.enabled && countries.length) {
			setIsMaintenance(countries.includes(localStorage.getItem(AsyncStorageKeys.RegionOverride)));
		} else {
			setIsMaintenance(maintenanceMode.enabled);
		}

		clearTimeout(maintenanceModeInterval);

		maintenanceModeInterval = setTimeout(() => {
			validateMaintenanceMode();
			AppLogger.log("MAINTENANCE-MODE", `Running every ${settings.configPollingIntervalSeconds}`);
		}, settings.configPollingIntervalSeconds * 1000);
	};

	const setUpUserOptions = async (session: string, apikey: string) => {
		const response: any = await getUserOptions(session, apikey);

		if (!response.userOptions.length) return;

		response.userOptions.forEach((item: any) => {
			const isEnabled = item.isEnabled;

			switch (item.optionId) {
				case UserOptionSettings.AcceptData:
					setAcceptData(isEnabled);
					break;
				case UserOptionSettings.GoogleAnalytics:
					setGoogleData(isEnabled);
					setOtherData(isEnabled);
					break;
				case UserOptionSettings.VideoAnalytics:
					setVideoAnalyticsData(isEnabled);
					setOtherData(isEnabled);
					break;
			}
		});
	};

	const narrowBreakpoint = (width: number, height: number) => {
		const aspectRatio = Math.ceil(width / height);
		let scale: number = 1;
		let formattedScale: number = 0;
		AppLogger.log("aspectRatio: ", aspectRatio);

		if (aspectRatio === 4) {
			scale = height / 520;
			formattedScale = scale > 1 ? scale : Math.round(scale);
			viewport?.setAttribute("content", `width=device-height, initial-scale=${formattedScale.toFixed(1)}, user-scalable=no`);
			setIsNarrow(true);
			return;
		}

		if (aspectRatio === 3) {
			scale = height / 904;
			scale = scale > 1 ? scale : Math.round(scale);
		}

		viewport?.setAttribute("content", `width=device-height, initial-scale=${scale}, user-scalable=no`);
		setIsNarrow(false);
	};

	/**
	 * Checks if the User is already logged in
	 */
	useEffect(() => {
		(async () => {
			// @ts-ignore
			const session = await AsyncStorage.getItem(AsyncStorageKeys.session);
			const apiKey = await AsyncStorage.getItem(AsyncStorageKeys.apiKey);

			if (session && apiKey && isLoggedIn) {
				globalAny.SESSIONKEY = session;
				globalAny.APIKEY = apiKey;
			}
			await setUserLoginSessionInfo();
		})();
	}, [isLoggedIn]);

	/**
	 * Initializes user options and location data from AsyncStorage.
	 * Runs once when the component mounts.
	 */
	useEffect(() => {
		(async () => {
			const session = localStorage.getItem(AsyncStorageKeys.session);
			const apiKey = localStorage.getItem(AsyncStorageKeys.apiKey);
			const isOverride = localStorage.getItem(AsyncStorageKeys.isOverride);

			if (session && apiKey) {
				try {
					await setUpUserOptions(session, apiKey);

					if (isOverride) return;
					const result: any = await getLocation(session, apiKey);
					localStorage.setItem(AsyncStorageKeys.svodCountryId, result?.svodCountryId ?? 0);
				} catch (error) {
					AppLogger.error(error);
				}
			}
		})();
	}, [localStorage.getItem(AsyncStorageKeys.session)]);

	/**
	 * Checks if the User is already logged in
	 */
	useEffect(() => {
		let mounted = true;
		const deviceIdentifier = localStorage.getItem(AsyncStorageKeys.deviceIdentifier);

		if (mounted) {
			if (!deviceIdentifier) localStorage.setItem(AsyncStorageKeys.deviceIdentifier, `Web${new Date().getTime()}`);
		}

		validateMaintenanceMode();

		return () => {
			mounted = false;
			AppLogger.log("MAINTENANCE-MODE", "stopped");
			clearTimeout(maintenanceModeInterval);
		};
	}, []);

	useEffect(() => {
		if (isLogout) setShowLogout(true);
	}, [isLogout]);

	useEffect(() => {
		clearInterval(logoutInterval);
		if (isTimerRunning) {
			clearInterval(logoutInterval);
			setLogoutCountDown(60);
			logoutInterval = setInterval(() => {
				if (logoutCountDown !== 0) setLogoutCountDown((prevCountDown) => prevCountDown - 1);
				const idleExpiry = localStorage.getItem(AsyncStorageKeys.idleExpiry);
				if (!idleExpiry) return;
			}, 1000);
		}
		return () => {
			clearInterval(logoutInterval);
		};
	}, [showIdleModal, isTimerRunning]);

	useEffect(() => {
		if (showIdleModal) {
			if (logoutCountDown === 0) {
				idleLogout();
			}
		}
	}, [logoutCountDown]);

	useEffect(() => {
		if (isLoginSuccess) {
			clearInterval(loginInterval);
			loginInterval = setInterval(() => {
				if (loginCountDown !== 0) setLoginCountDown((prevCountDown) => prevCountDown - 1);
			}, 1000);
		}
		return () => {
			clearInterval(loginInterval);
		};
	}, [loginCountDown, isLoginSuccess]);

	useEffect(() => {
		const subscription = Dimensions.addEventListener("change", ({ window, screen }) => {
			setDimensions({ window, screen });
		});

		//@ts-ignore
		return () => subscription?.remove();
	}, []);

	useEffect(() => {
		if (width && height) {
			narrowBreakpoint(width, height);
		} else {
			viewport?.setAttribute("content", "width=device-width, initial-scale=1, user-scalable=no");
		}
	}, [width, height]);

	useEffect(() => {
		const sessionExpired = localStorage.getItem(AsyncStorageKeys.sessionExpired);

		if (sessionExpired === "true") {
			setShowLogout(true);
		}
	}, [localStorage.getItem(AsyncStorageKeys.sessionExpired)]);

	useEffect(() => {
		const networkError = localStorage.getItem(AsyncStorageKeys.networkError);
		if (networkError === "true") {
			setIsNetworkError(true);
			return;
		}
		setIsNetworkError(false);
	}, [localStorage.getItem(AsyncStorageKeys.networkError)]);

	/**
	 * useEffect hook runs when `isScreenSelection` changes.
	 * If both `isScreenSelection` and `isUrlValidation` are false,
	 * it triggers customer zone validation by calling
	 * `validateCustomerZone(CustomerZoneEnum.RandomDevice)` as the default value.
	 */
	useEffect(() => {
		if (!isScreenSelection && !isUrlValidation && !localStorage.getItem(AsyncStorageKeys.deviceId))
			validateCustomerZone(CustomerZoneEnum.RandomDevice);
	}, [isScreenSelection]);

	if (checkingLoginInfo || isAppNotSupported) {
		const currentUrl = window.location.href;
		return currentUrl.includes(Pages.landing) ? <InitialLandingLoader /> : <LandingLoader />;
	}

	return (
		<>
			{children}
			{isMaintenance ? (
				<CustomizeDialogBox
					Header={globalAny.language.maintenance_mode_title}
					Body={globalAny.language.maintenance_mode_description}
					ButtonTextRight={globalAny.language.ok}
					SingleButton={true}
					CloseButton={false}
					Width={680}
					Height={"auto"}
					TypeButtonColorRight={ComponentTypeEnum.Primary}
					onPressRight={() => logout()}
				/>
			) : (
				<></>
			)}
			{showIdleModal ? (
				<CustomizeDialogBox
					Header={globalAny.language.modal_logout_header}
					Body={modalBody()}
					ButtonTextLeft={globalAny.language.keep_me_logged_in}
					ButtonTextRight={globalAny.language.logout}
					hasSubTextLeft={true}
					SingleButton={false}
					CloseButton={false}
					Width={680}
					Height={"auto"}
					TypeButtonColorLeft={ComponentTypeEnum.Tertiary}
					TypeButtonColorRight={ComponentTypeEnum.Secondary}
					onPressLeft={idleLogin}
					onPressRight={idleLogout}
				/>
			) : (
				<></>
			)}
			{isSigninLoading ? (
				<Toast
					visible={isSigninLoading}
					text={globalAny.language.validating_credentials}
					type={ComponentTypeEnum.Processing}
					onDismissSnackBar={() => setIsSigninLoading(false)}
				/>
			) : (
				<></>
			)}
			{showLogout ? (
				<Toast
					visible={showLogout}
					text={globalAny.language.session_expired}
					type={ComponentTypeEnum.Secondary}
					onDismissSnackBar={onDismissSnackBar}
				/>
			) : (
				<></>
			)}
			{isLoginSuccess ? (
				<Toast
					visible={isLoginSuccess}
					text={`${globalAny.language.login_succes} (${loginCountDown}) `}
					type={ComponentTypeEnum.Primary}
					onDismissSnackBar={() => setLoginCountDown(5)}
					duration={6000}
				/>
			) : (
				<></>
			)}

			{isNetworkError ? (
				<Toast
					visible={isNetworkError}
					text={globalAny.language.network_error}
					type={ComponentTypeEnum.Error}
					onDismissSnackBar={() => setIsNetworkError(false)}
					label={globalAny.language.label_retry}
					onPress={() => {
						setIsNetworkError(false);
						setIsRetryTriggered(true);
					}}
				/>
			) : (
				<></>
			)}

			{isDebugVisible && <DebugDialog onDismiss={() => setIsDebugVisible(false)} />}
		</>
	);
};
export default SessionWrapper;
